import Api from '../../../services/Api'
import { useContext, useState } from 'react'
import { TicketDetailsContext } from '../context'
import useToastify from '../../../hook/useToastify'

export default function useOnDocumentUpload() {
  const {ticketId, projectId} = useContext(TicketDetailsContext)
  const [isLoading, setIsLoading] = useState(false)
  const {toastMessage} = useToastify()

  const onUploadDocuments = async (documents: any) => {
    setIsLoading(true)
    const response = await Api.post(
      `/agile/projects/${projectId}/attachments/${ticketId}`,
      documents,
      {},
      {}
    )
    setIsLoading(false)
    if (response?.status === 200) {
      toastMessage('success', 'File uploaded successfully.')
    } else {
      toastMessage('error', 'Something went wrong. Please attach the file again.')
    }
    return response
  }

  const onDeleteDocument = async (filename: any) => {
    setIsLoading(true)
    const response = await Api.delete(
      `/agile/projects/cards/${ticketId}/attachments?file_names=${filename}&project_id=${projectId} `,
      {},
      null,
      null
    )
    setIsLoading(false)
    if (response?.status === 200) {
      toastMessage('success', 'File deleted successfully.')
    } else {
      toastMessage('error', 'Something went wrong. Please delete the file again.')
    }
    return response
  }

  return {
    onUploadDocuments: onUploadDocuments,
    onDeleteDocument: onDeleteDocument,
    isLoading,
  }
}